import React from "react";
import { Table } from "reactstrap";
import NeoAlert from "../../../components/Common/NeoAlert";
import NeoButton from "../../../components/Common/NeoButton";
import NeoCard from "../../../components/Common/NeoCard";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import usePlatformPermissions from "./hooks/usePlatformPermissions";
import { PERMISSION_LABELS, ROLE_LABELS } from "./constants";

const PlatformPermissions = () => {
    const {
        rolesPermissions,
        loading,
        saving,
        dirty,
        error,
        alertText,
        togglePermission,
        saveMatrix,
        dismissAlert,
    } = usePlatformPermissions();

    const roleKeys = Object.keys(rolesPermissions);

    return (
        <div className="pb-5">
            <div className="mb-4">
                <Breadcrumb title="Permissões" />
            </div>

            {alertText && (
                <NeoAlert color="warning" toggle={dismissAlert} className="mb-4 shadow-sm border-0">
                    {alertText}
                </NeoAlert>
            )}

            {error && (
                <NeoAlert color="danger" className="mb-4 shadow-sm border-0">
                    {error}
                </NeoAlert>
            )}

            <NeoCard
                title="Matriz de Autorizações do SaaS"
                subtitle="Defina o que cada cargo pode acessar no painel. Ao salvar, as permissões são aplicadas a todos os usuários internos do cargo."
                headerIcon="mdi-key-outline"
                headerActions={
                    <NeoButton
                        variant="primary"
                        size="sm"
                        onClick={saveMatrix}
                        disabled={!dirty || saving || loading}
                    >
                        <i className="ph-light ph-floppy-disk fs-5 me-1" />
                        {saving ? "Salvando..." : "Salvar Alterações"}
                    </NeoButton>
                }
                thinBorder={true}
                bodyClassName="p-0"
            >
                {loading ? (
                    <div className="text-center py-5 text-muted">Carregando matriz de permissões...</div>
                ) : (
                    <div className="table-responsive">
                        <Table className="table align-middle mb-0">
                            <thead>
                                <tr>
                                    <th style={{ width: "300px", paddingLeft: "24px" }}>Página / Permissão</th>
                                    {roleKeys.map((roleKey) => (
                                        <th key={roleKey} className="text-center">{ROLE_LABELS[roleKey] || roleKey}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {PERMISSION_LABELS.map((perm) => (
                                    <tr key={perm.key}>
                                        <td className="fw-semibold text-dark" style={{ paddingLeft: "24px" }}>{perm.label}</td>
                                        {roleKeys.map((roleKey) => {
                                            const isGranted = rolesPermissions[roleKey]?.[perm.key] === true;
                                            return (
                                                <td key={roleKey} className="text-center">
                                                    <div
                                                        className="d-inline-flex align-items-center justify-content-center rounded-circle"
                                                        style={{
                                                            width: "32px",
                                                            height: "32px",
                                                            backgroundColor: isGranted ? "rgba(46, 125, 50, 0.08)" : "rgba(198, 40, 40, 0.08)",
                                                            color: isGranted ? "#2e7d32" : "#c62828",
                                                            cursor: roleKey === "owner" ? "not-allowed" : "pointer",
                                                        }}
                                                        onClick={() => togglePermission(roleKey, perm.key)}
                                                        title={isGranted ? "Clique para revogar" : "Clique para liberar"}
                                                    >
                                                        <i className={`ph-light ${isGranted ? "ph-check-bold" : "ph-x-bold"}`} />
                                                    </div>
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                )}
            </NeoCard>
        </div>
    );
};

export default PlatformPermissions;
